import { render, staticRenderFns } from "./ChangeSite.vue?vue&type=template&id=630d2712&scoped=true&"
import script from "./ChangeSite.vue?vue&type=script&lang=js&"
export * from "./ChangeSite.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSite.vue?vue&type=style&index=0&id=630d2712&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d2712",
  null
  
)

export default component.exports